
document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener("click", async function (event) {
    const target = event.target.closest(".compare, .add-to-cart, .remove-from-compare, .remove-all-btn");
    if (!target) return;
    event.preventDefault();

    // ---------- OPEN MODAL ----------
    if (target.classList.contains("compare")) {
      const productHandle = target.getAttribute("data-product-handle");

      const compareModal = document.getElementById("compare-modal");
      if (compareModal) {
        const modalInstance = bootstrap.Offcanvas.getOrCreateInstance(compareModal);
        modalInstance.show();
      }

      fetch(`/products/${productHandle}.js`)
        .then((res) => res.json())
        .then((product) => {
          addProductToCompare(product);
          updateCompareUI();
        });
    }

    if (target.classList.contains("add-to-cart")) {
      event.preventDefault();

      const variantId = target.dataset.variantId;
      if (!variantId) return;

      if (target.classList.contains("loading")) return;

      target.classList.add("loading");
      target.disabled = true;

      try {
        await addToCart(variantId);
      } catch (e) {
        console.error("Add to cart failed", e);
      }

      target.classList.remove("loading");
      target.disabled = false;
    }

  if (target.classList.contains("remove-from-compare")) {
    event.preventDefault();

    const productId = target.dataset.productId;
    removeProductFromCompare(productId);
  }

    if (target.classList.contains("remove-from-compare")) {
      const productId = target.getAttribute("data-product-id");
      removeProductFromCompare(productId);
    }
  });

  function updateCompareUI() {
    const products = JSON.parse(localStorage.getItem("compareProducts")) || [];

    renderTable({
      loader: "compareLoaderModal",
      content: "compareContentModal",
      empty: "compareEmptyModal",
      body: "compareBodyModal"
    }, products);

    renderTable({
      loader: "compareLoaderPage",
      content: "compareContentPage",
      empty: "compareEmptyPage",
      body: "compareBodyPage"
    }, products);

    updateCompareCount();
    initVStarRatings();
  }

  function formatPrice(priceInCents) {
    const activeCurrency = window?.Shopify?.currency?.active || 'USD';
    const rate = window?.Shopify?.currency?.rate || 1;

    const convertedPrice = (priceInCents / 100) * rate;

    let formatted = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: activeCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(convertedPrice);

    if (activeCurrency.toUpperCase() === 'INR') {
      formatted = formatted.replace('₹', '').trim();
      return 'Rs. ' + formatted;
    }

    return formatted;
  }
  function renderTable(sectionIDs, products) {
  const loader = document.getElementById(sectionIDs.loader);
  const content = document.getElementById(sectionIDs.content);
  const empty = document.getElementById(sectionIDs.empty);
  const body = document.getElementById(sectionIDs.body);

  if (!loader || !content || !empty || !body) return;

  loader.classList.remove("d-none");
  content.classList.add("d-none");
  empty.classList.add("d-none");

  body.innerHTML = "";

  if (products.length === 0) {
    loader.classList.add("d-none");
    empty.classList.remove("d-none");
    return;
  }

  let html = `<div class="compare-cards">`;

  products.forEach(product => {
    const variantId = product.variants?.[0]?.id ?? "";
    const hasAvailableVariant = product.variants?.some(v => v.available);


      let optionDisplay = "";

      if (product.options && product.options.length > 1) {
        product.options.forEach((opt, index) => {
          const values = product.variants
            ?.map(v => v.options[index])
            ?.filter((v, i, arr) => arr.indexOf(v) === i)
            ?.join(", ");

          if (values) {
            optionDisplay += `
              <div class="compare-vt">
                <strong>${opt.name}:</strong> ${values}
              </div>
            `;
          }
        });
      }

    html += `
      <div class="compare-card">
        <button class="remove-from-compare" data-product-id="${product.id}">×</button>

        <a href="${product.url}" class="compare-image">
          <img src="${product.featured_image}&width=241" data-src="${product.featured_image}&width=241" loading="lazy" class="lazy-collection">
        </a>

        <h5 class="compare-title">
          <a href="${product.url}">${product.title}</a>
        </h5>

        <div class="compare-price">${formatPrice(product.price)}</div>

        <div class="compare-rating">
          <div class="custom-vstar-rating-widget" data-product-id="${product.id}"></div>
        </div>
        
        ${hasAvailableVariant ? `
        <div class="compare-variant">${optionDisplay || "-"}
        </div>
        ` : ""}

        <div class="compare-type">
          <strong>Type:</strong> ${product.type}
        </div>

        <div class="compare-stock ${product.available ? 'in-stock' : 'out-stock'}">
          ${product.available ? "In Stock" : "Out of Stock"}
        </div>

        <div class="compare-actions">
          <button class="btn add-to-cart" data-variant-id="${variantId}">
            Add to Cart
          </button>
          <button class="remove-from-compare position-relative btn" data-product-id="${product.id}">Remove</button>
        </div>
      </div>
    `;
  });

  html += `</div>`;
  body.innerHTML = html;

  loader.classList.add("d-none");
  content.classList.remove("d-none");
}

  function clearAllCompare() {
    localStorage.removeItem("compareProducts");
    updateCompareUI();
  }
  document.querySelectorAll('.remove-all-btn').forEach(btn => {
    btn.addEventListener('click', clearAllCompare);
  });
  function addProductToCompare(product) {
    let list = JSON.parse(localStorage.getItem("compareProducts")) || [];
    if (!list.some(p => p.id === product.id)) list.push(product);
    localStorage.setItem("compareProducts", JSON.stringify(list));
  }

  function removeProductFromCompare(id) {
    let list = JSON.parse(localStorage.getItem("compareProducts")) || [];
    list = list.filter(p => p.id != id);
    localStorage.setItem("compareProducts", JSON.stringify(list));
    updateCompareUI();
  }

  function updateCompareCount() {
    const count = JSON.parse(localStorage.getItem("compareProducts"))?.length || 0;
    const counter = document.getElementById("compareCount");
    if (counter) counter.textContent = count;
  }

  async function addToCart(id) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, quantity: 1 })
    });
  }

  function initVStarRatings() {
    if (window.TRS?.reloadWidgets) {
      setTimeout(() => window.TRS.reloadWidgets(), 300);
    }
  }

  updateCompareUI();
});
